module.exports = __webpack_public_path__ + "static/media/polytope_5_3_3_cell120_layers_3_3.7ab66c6e.gif";